

























import { Component, Vue, Prop } from "vue-property-decorator";
import Button from "@/components/Button/Button.vue";
@Component({
  components: { Button }
})
export default class SingleOffer extends Vue {
  @Prop({ default: "" })
  private iconName!: string;
  @Prop({ default: "" })
  private likeClass!: string;
  @Prop({ default: "" })
  private text!: string;
  @Prop({ default: {} })
  private singleOffer!: any;

  get leftImgSrc() {
    const name =
      this.likeClass === "follow"
        ? "lh_special_one_follower"
        : "lh_special_one_like";
    return require(`@/assets/icons-file/special_offer/${name}@3x.png`);
  }

  private buyOffer() {
    this.$emit("buyOffer", this.singleOffer);
  }
}
